import { Badge, Box, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import React from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../../hooks/use-open-article-by-editor-host';
import { ColorContrastElementGenericTimeline } from './color-contrast-element-generic-timeline';
export const ColorContrastElementGenericContent = _ref => {
  let {
    locale,
    minimalRatio,
    elementIndex,
    status,
    failedElement,
    onClickCancel,
    onClickApply,
    showLoader,
    pageId
  } = _ref;
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const {
    editorHost
  } = useA11yWizardAdapter();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      learnMore: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        target: "_blank",
        underline: "always",
        onClick: () => {
          openSelectedArticle(editorHost, 'editor-package-accessibility-wizard.articles-color-contrast-manual-fix-help');
          biLogger.taskElementCtaClick({
            ctaName: BiCtaNames.LearnMore,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      }),
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      })
    },
    i18nKey: status ? 'accessibility-wizard.rules-list.color-contrast.element.content.generic.success' : 'accessibility-wizard.rules-list.color-contrast.element.content.generic.failed'
  })), !status && /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "B60",
    borderRadius: "6px",
    direction: "vertical",
    gap: "SP2",
    padding: "9px 0 29px SP2"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Badge, {
    noPadding: true,
    showTooltip: false,
    size: "tiny",
    skin: "neutralStandard",
    type: "solid",
    uppercase: false
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0 4px"
  }, t('accessibility-wizard.rules-list.content.generic.badge')))), /*#__PURE__*/React.createElement(ColorContrastElementGenericTimeline, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    locale: locale,
    minimalRatio: minimalRatio,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  })));
};
//# sourceMappingURL=color-contrast-element-generic-content.js.map